import React from "react";
import { Box, ScaleFade } from "@chakra-ui/react";

const MenuList = ({ children, setIsOpen }) => {
  const _children = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { setIsOpen });
    }
    return child;
  });

  return (
    <ScaleFade initialScale={0.9} in={true}>
      <Box borderRadius={4} boxShadow={4} background={"#fff"}>
        {_children}
      </Box>
    </ScaleFade>
  );
};

export default MenuList;
